module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.state.error) ? _c('page-error') : _c('breadcrumbs-layout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [_c('card-page-layout', {
    attrs: {
      "title": _vm.state.name,
      "geo": _vm.geo,
      "review-count": _vm.reviewsCount,
      "descriptionProps": _vm.descriptionProps,
      "sidebarProps": _vm.sidebarProps,
      "offsetSetup": _vm.isHasModulePfdod,
      "teachersList": _vm.teachersList,
      "modulesList": _vm.modulesList,
      "currentView": _vm.currentTab
    },
    on: {
      "need-reviews": _vm.loadReviews,
      "need-questionnaire": _vm.loadQuestionnaire,
      "tab-changed": _vm.onChangeTab
    }
  }, [(_vm.isEventRequest) ? _c('template', {
    slot: "eventRequest"
  }, [_c('EventRequestForm', {
    attrs: {
      "users": _vm.requestUsers,
      "isLoading": _vm.isLoading,
      "is-request-executed": _vm.isRequestExecuted,
      "message": _vm.requestFinishMsg,
      "errors": _vm.requestErrors
    },
    on: {
      "submitRequest": _vm.submitRequest,
      "understood": _vm.closeEventRequestForm,
      "cancelRequest": _vm.closeEventRequestForm
    }
  })], 1) : _vm._e(), _c('ButtonCanRequest', {
    attrs: {
      "slot": "sidebarButtonPlace",
      "isPossible": _vm.canRequest,
      "wide": true,
      "disabledRequest": _vm.disabledRequest
    },
    on: {
      "click": _vm.onRequest
    },
    slot: "sidebarButtonPlace"
  }), _c('ButtonDeferred', {
    attrs: {
      "slot": "sidebarAfterButton"
    },
    slot: "sidebarAfterButton"
  }), _c('NewProgramButton', {
    attrs: {
      "slot": "sidebarAfterButton"
    },
    on: {
      "program": _vm.openAddProgramForm
    },
    slot: "sidebarAfterButton"
  }), _c('reviews-block', {
    attrs: {
      "slot": "compReview",
      "reviews": _vm.reviews,
      "reviewSuccess": _vm.reviewPopup,
      "reviewError": _vm.reviewError,
      "userData": _vm.userData,
      "auth": _vm.isAuthorized
    },
    on: {
      "submitReview": _vm.submitReview,
      "closePopup": _vm.closePopup
    },
    slot: "compReview"
  }), _c('Questionnaire', {
    attrs: {
      "slot": "questionnaire",
      "auth": _vm.isAuthorized,
      "error": _vm.anketaError,
      "noitemText": _vm.noItemText,
      "messageText": _vm.messageText,
      "showMessage": _vm.showAnketaMessage,
      "isAnketaLoading": _vm.isAnketaLoading,
      "allQuestionnaire": _vm.allQuestionnaire,
      "mainDescription": _vm.mainAnketaDescription
    },
    on: {
      "formSubmit": _vm.formSubmit,
      "getQuestionList": _vm.getLists,
      "closeWarning": _vm.closeAnketaWarning
    },
    slot: "questionnaire"
  }), (_vm.isHasBadges) ? _c('slider-badges', {
    attrs: {
      "slot": "badges",
      "interval": 3000,
      "items": _vm.badgesList
    },
    slot: "badges"
  }) : _vm._e(), _c('slider-images', {
    attrs: {
      "slot": "slider",
      "items": _vm.sliderImages,
      "color": _vm.colorMenuSection
    },
    slot: "slider"
  }), _c('ButtonCanRequest', {
    attrs: {
      "slot": "footer",
      "isPossible": _vm.canRequest,
      "wide": false,
      "disabledRequest": _vm.disabledRequest,
      "requestTooltipText": _vm.requestTooltipText
    },
    on: {
      "click": _vm.onRequest
    },
    slot: "footer"
  })], 2), (_vm.eventsRecommendedList) ? _c('extra-layout', {
    attrs: {
      "slot": _vm.recommendPosition,
      "bg": "gray"
    },
    slot: _vm.recommendPosition
  }, [_c('recommended-list', {
    attrs: {
      "usePadding": true,
      "items": _vm.eventsRecommendedList,
      "doubler": false
    }
  }, [_c('h3', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Рекомендуем посмотреть")])])], 1) : _vm._e()], 1), (_vm.listOfCards.length) ? _c('ExtraLayout', {
    attrs: {
      "bg": "gray"
    }
  }, [(_vm.eduPartnersList && _vm.eduPartnersList.length) ? _c('AppCardsList', {
    attrs: {
      "title": "Обучающие организации"
    }
  }, _vm._l((_vm.eduPartnersList), function(item, index) {
    return _c('MiniCard', {
      key: index,
      attrs: {
        "route-name": "organization",
        "id": item.id,
        "title": item.name,
        "image": item.images ? item.images.url : null
      }
    })
  }), 1) : _vm._e(), _vm._l((_vm.listOfCards), function(item) {
    return _c('AppCardsList', _vm._b({
      key: item.title
    }, 'AppCardsList', item, false))
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45787150","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/event/card/Card.vue
// module id = 33c8470b532c2c5edb04
// module chunks = 5